import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
} from '@angular/common/http';
import { Observable, throwError} from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthenticationService } from '@app/core/authentication';


@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

    // For the below 'excludedUrlSuffixes' the error needs to be passed to the controller so it can be properly handled there.
    // These calls are happening from the login page so also no page reload is needed.
    private readonly excludedUrlSuffixes = [
        '/login/login', 
        '/login/multi_login', 
        '/login/recovery', 
        '/login/verify',
        '/login/mfa_login',
        '/clients/user/changePassword', 
    ];

    private readonly logout409ResultCodes = [
        'AccessTokenExpired',
        'UserSessionRunning'
    ];

    constructor(private authenticationService: AuthenticationService) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request)
                   .pipe(catchError(err => {
            if ((err.status === 401 && err.url && !this.excludedUrlSuffixes.find(suffix => err.url.indexOf(suffix) > -1)) ||
                (err.status === 409 && err.error && this.logout409ResultCodes.indexOf(err.error.resultCode) > -1)) {
                // auto logout if 401 response returned from api, unless we are on a specific login related page
                // or on 409 with specific error resultCode
                this.authenticationService.removeUserToken();
                location.reload();
            } else {
                return throwError(err);
            }
        }));
    }
}
